import { useEffect } from "react";

interface IUseIsolateOverlayEventsOptions {
    isActive: boolean;
    targetRef: React.RefObject<HTMLElement | null>;
}

export const useIsolateOverlayEvents = ({ isActive, targetRef }: IUseIsolateOverlayEventsOptions) => {
    useEffect(() => {
        const target = targetRef.current;
        if (!isActive || !target) {
            return;
        }

        const controller = new AbortController();

        target.addEventListener(
            "keydown",
            (event) => {
                if (event.key === "Escape") {
                    event.stopPropagation();
                }
            },
            { signal: controller.signal },
        );

        return () => controller.abort();
    }, [isActive, targetRef]);
};
